import { Container, LinkBoxList } from 'ui/components';

import styles from './DynamicBottomMenu.module.scss';

export interface DynamicBottomMenuProps {
	title?: string;
	backButtonLabel?: string;
	backUrl?: string;
	links: Umbraco.Link[];
	containerWidth?: Models.SectionWidth;
}

export const DynamicBottomMenu: React.FC<DynamicBottomMenuProps> = ({ title, backButtonLabel, backUrl, links, containerWidth = 'Standard' }) => {
	if (links.length === 0) return null;

	const backButton: Umbraco.Link = backButtonLabel && backUrl ? { name: backButtonLabel, url: backUrl, target: '_self' } : undefined;

	return (
		<Container width={containerWidth} className={styles.DynamicBottomMenu}>
			<LinkBoxList
				items={[{ heading: title, links: links, variant: 'inline', backButton }]}
				desktopWidth="100"
				mobileWidth="100"
				containerWidth="Standard"
			/>
		</Container>
	);
};
